<template>
	<div class="ReInputContact">
		<label class="mt-3" v-if="label"><span>{{ label }}</span></label>

		<div class="row cc-item">
			<div class="fieldset col-md-9" >
				<el-select v-if="contactGroup_options.length > 0"
						class="select-primary"
						placeholder="Тип Контакта"
						v-model="value.contact_type"
				>
					<el-option
						v-for="(sel_opt, sel_index) in contactGroup_options"
						class="select-primary"
						:value="sel_opt.value"
						:label="sel_opt.label"
						:key="sel_index"
					>
					</el-option>
				</el-select>
				<base-input	v-if="value.contact_group=='phone'" :disabled="value.contact_type===disableByOptId"
					
					:placeholder="comp_placeholder(value.contact_type)"
					:mask="'phone'"
					v-model="value.contact_value"
				>
				</base-input>
			</div>
		</div>
	</div>
</template>

<script>
	import {Select, Option} from 'element-ui';
	export default {
		name: 'ReInputContactSimple',
		components: {
			[Option.name]: Option,
        	[Select.name]: Select,
		},
		props: {
			value: {
				type: Object,
				default(){return {
					contact_id: '',
					contact_type: '',
					contact_value: '',
					contact_view: '',
				};}
			},
			contactGroup: String,
			contactGroup_options:{
				type: Array,
				default(){return [];}
			},
			placeholder: [String, Object],
			required:{
				type: Boolean,
				default: false
			},
			//errorLabel: String,
			label: String,
			disableByOptId: [String, Number],
		},
		data () {
			return {
				ver: 1,
				masContacts:[],
				validation:{
					required: {
						required: true
					},
					email:{
						email: true
					},
					phone:{
						regex: /^((8|\+7)[\- ]?)?(\(?\d{3}\)?[\- ]?)?[\d\- ]{7,10}$/
					},
					web:{
						url: {require_protocol: true }
					},
					messanger:{
						min: 3
					},
					social:{
						url: {require_protocol: true }
					},
				},
				bClientExists: false,
				masClientExists: [],
				idClientExists: -1,
				iValueClientExists: -1,
				isShown: true,
				isAttentionNote: true,
				opacityOn: false,
			}
		},
		computed: {
			
		},
		methods: {
			/*
			opacityOnSwitch() {
				this.opacityOn = true;
				setTimeout(() => {
					this.opacityOn = false;
				}, 2500)
			},
			
			applyView(ind,viewType){
				this.value[ind].contact_view = viewType;
			},
			
			getError(fieldName) {
				return this.errors.first(fieldName);
			},
			*/
			comp_placeholder(strType){
				if(typeof this.placeholder == 'object'){
					if(strType !=''){
						for (let i = 0; i < this.contactGroup_options.length; i++) {
							if(this.contactGroup_options[i].value == strType){
								return this.placeholder[this.contactGroup_options[i].label];
							}							
						}
					}else{
						return 'Введите ...';
					}
				}
				return this.placeholder;
			},
			
		},
		created(){

		}
	}
</script>
<style scoped>
	.ReInputContact .fieldset{
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	.ReInputContact .fieldset > *{
		width: 100%; 
		margin-bottom: 0px;
	}
	.ReInputContact .fieldset:not(.no-select) > div:nth-child(1){width: 250px;}
	.ReInputContact .btnGroup{
		display: flex;
		align-items: center;
	}
	.cc-item{
		/*margin-bottom: 15px;*/
	}
	.ReInputContact >>> .el-input__inner {font-size: 0.75rem;}
	.ReInputContact >>> .fieldset > div:nth-child(2) .form-control {height: 38px;}

	.clientExists > *{display: block;}
	.clientExists {display: flex; flex-wrap: wrap;}
	.messicon {
		width: 18px;
		height: 18px;
		display: inline-block;
	}
	.messicon-bg {background:#044c60;}
	.messicon-telegram {background: url('/img/icons/telegramlogo.svg') no-repeat; }
	.messicon-whatsapp {background: url('/img/icons/whatsapplogo.svg') no-repeat; }
	.messicon-viber {background: url('/img/icons/viberlogo.svg') no-repeat; }
	.success-copy {height: 1.3rem;}


	/* .messicon-skype {background: url('/img/icons/skypelogo.svg') no-repeat; } */

	/*
	Этот код вынесен в src/assets/sass/dashboard/custom/_global.scss т.к. там работает, а тут нет - хз почему
	.ReInputContact .fieldset > div:nth-child(2) .form-control{height:40px;}
	.ReInputContact .fieldset:not(.no-select) > div:nth-child(1) input{
		border-top-right-radius: 0;
		border-bottom-right-radius: 0;
	}
	.ReInputContact .fieldset > div:nth-child(2) input{
		border-top-left-radius: 0;
		border-bottom-left-radius: 0;
	}
	.ReInputContact .btnGroup .btn.dropdown-toggle[data-toggle="dropdown"]{margin-bottom: 0px !important;}
	*/
</style>
